define('TechSpecs', [
  'TechSpecs.View'
], function(
  TechSpecsView
) {
  'use strict';

  return {
    mountToApp: function mountToApp(container) {
      var pdp = container.getComponent('PDP');
      pdp.addChildView('TechSpecs', function () {
        return new TechSpecsView({ container: container, pdp: pdp });
      });
    }
  };

});
